import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import FilterNoneIcon from "@mui/icons-material/FilterNone";
import { Grid, Divider } from "@mui/material";
import Chip from "@mui/material/Chip";
import AcUnitIcon from "@mui/icons-material/AcUnit";

export default function CustomizedDialogs(props) {
  const { InstanceID } = props;
  const [open, setOpen] = React.useState(false);
  const [instancelog, setinstancelog] = React.useState([]);

  const handleClickOpen = () => {
    setOpen(true);
    fetch(
      `${process.env.REACT_APP_API_URL}/api/wiseactivelog/${InstanceID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setinstancelog(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  
  const handleClose = () => {
    setOpen(false);
  };

  function DateTime1(startDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startDate1 = new Date(startDate).toLocaleString("en-GB", {
      timeZone: `${timezone}`,
    });
    const startDate2 = startDate1.split(",");
    const startDatef = startDate2[0].replace("/", "-");
    const startDate3 = startDatef.replace("/", "-");
    return startDate3;
  }

  function DateTime2(startDate, startTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startTime1 = new Date(
      startDate + "T" + startTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startTime2 = startTime1.split(",");
    const startTime3 = startTime2[1].substring(0, 6);
    return startTime3;
  }

  // Column content style
  const columnStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  // Column header style
  const headerStyle = {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  return (
    <div>
      <MenuItem onClick={handleClickOpen}>
        <IconButton aria-label="Filter" color="secondary">
          <FilterNoneIcon /> &nbsp;&nbsp;
          <span style={{ fontSize: "0.7em", color: "#172B4D" }}>Log</span>
        </IconButton>
      </MenuItem>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        scroll="paper"
        open={open}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          <Chip
            icon={<AcUnitIcon />}
            label="Active log"
            clickable
            color="primary"
          />
        </DialogTitle>
        <DialogContent dividers>
          <Grid container justifyContent="center">
            <Grid item>
              <Typography variant="subtitle1" color="textSecondary" gutterBottom>
                UTC time is displayed here.
              </Typography>
            </Grid>
          </Grid>
          
          {/* Header Row */}
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <Typography variant="subtitle1" style={headerStyle}>
                Channel
              </Typography>
              <Divider />
            </Grid>
            <Grid item xs={3}>
              <Typography variant="subtitle1" style={headerStyle}>
                Status
              </Typography>
              <Divider />
            </Grid>
            <Grid item xs={2}>
              <Typography variant="subtitle1" style={headerStyle}>
                Date
              </Typography>
              <Divider />
            </Grid>
            <Grid item xs={1}>
              <Typography variant="subtitle1" style={headerStyle}>
                Time
              </Typography>
              <Divider />
            </Grid>
            <Grid item xs={3}>
              <Typography variant="subtitle1" style={headerStyle}>
                Executed by
              </Typography>
              <Divider />
            </Grid>
          </Grid>

          {/* Data Rows */}
          {instancelog.map((actdata, index) => (
            <React.Fragment key={index}>
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <Typography variant="body1" style={columnStyle}>
                    {actdata.channel}
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="body1" style={columnStyle}>
                    {actdata.action.replace(/_/g, ' ')}
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant="body1" style={columnStyle}>
                    {DateTime1(`${actdata.date}`)}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant="body1" style={columnStyle}>
                    {actdata.time ? DateTime2(`${actdata.date}`, `${actdata.time}`) : "NA"}
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="body1" style={columnStyle}>
                    {actdata.email.split('@')[0]}
                  </Typography>
                </Grid>
              </Grid>
              <Divider />
            </React.Fragment>
          ))}
        </DialogContent>
      </Dialog>
    </div>
  );
}